/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import history from './utils/history';
// import globalReducer from './containers/App/reducer';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */

const reducerAll = {
  // [REDUX_KEY.dashboard]: dashboardReducer,
};
export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    // global: globalReducer,
    router: connectRouter(history),
    ...injectedReducers,
    ...reducerAll,
  });

  return rootReducer;
}
